var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wf-yes-no-factor-display"},[_c('wf-yes-no-factor-edit',{attrs:{"question":_vm.question,"value":_vm.value,"readonly":true,"definition":_vm.definition,"instance":_vm.instance,"default-values":_vm.defaultValues}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }